"use strict";var r=require("../../Error-4c57126e.js");require("react"),require("styled-components"),require("prop-types"),require("../../Image-9c905037.js"),require("../../IconButton-f0b94197.js"),module.exports=r.Error;
